'use client';

import { observer } from 'mobx-react-lite';
import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';

import { urlParamsSearch } from 'constants/search';
import { deleteUrlQueryParam, updateUrlQueryParam } from 'utils/misc';

const Tabs = dynamic(() => import('@sympla/sympla-components/Tabs'), { ssr: false });

// import Tabs from '@sympla/sympla-components/Tabs';

export type TabItem = {
  label: string;
  tabName: string;
  ariaLabel: string;
};

type TabsNavigationProps = {
  handleChange?: (item: TabItem) => void;
  tabsList: {
    label: string;
    tabName: string;
    ariaLabel: string;
  }[];
};

function TabsNavigation({ handleChange, tabsList }: TabsNavigationProps) {
  const searchParams = useSearchParams();
  const activeTab = tabsList.find((tab) => tab.tabName === (searchParams?.get(urlParamsSearch.tab) as string | undefined)) || tabsList[0];

  function onTabChange(params: TabItem) {
    if (handleChange) {
      handleChange(params);
    }

    deleteUrlQueryParam({ param: urlParamsSearch.page });
    updateUrlQueryParam({ param: urlParamsSearch.tab, value: params.tabName });
  }

  return <Tabs activeTab={activeTab?.tabName} handleChange={onTabChange} tabsList={tabsList} />;
}

export default observer(TabsNavigation);
